import ExplainerVideos from 'routes/ExplainerVideos'

export default ExplainerVideos
